import RequestAbstract from "../abstract";

/**
 * Gateway settings: one gateway API configured for one kind — payin, payout,
 * payin_callback or payout_callback — which gateways then link, one row per kind.
 * Admins only: the settings hold bank logins and tokens, and every secret comes
 * back masked (`tok***def`); a save that sends the mask back keeps the stored one.
 */
export default class PublicGatewaySettings extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-gateway-settings";
    }

    /**
     * Each driver's settings as core describes them from its settings class, one per
     * gateway API and kind (`[{ api, kind, fields: [{ key, type, required, secret, … }] }]`):
     * what the settings editor's Form is built from, and what the cabinet checks a save against.
     */
    async schemas() {
        return await this.loadWithAuth(`${this.link}/schemas`, { method: 'GET' });
    }

}
